const ProjectData = [
  {
    key: 1,
    name: "Vegetarian Recipe Blog",
    image:
      "https://raw.githubusercontent.com/Project-WT/recipe-blog/master/Screenshots/article.JPG",
    image2:
      "https://raw.githubusercontent.com/Project-WT/recipe-blog/master/Screenshots/recipe1-1.JPG",
    url: "/work/Vegetarian Recipe Blog",
    props: [
      {
        title: "Angular JS",
        description:
          "The website is mostly frontend made using vanilla JS, CSS and Angular JS",
      },
      {
        title: "Project",
        description: "This website was my project for Web Tech Course",
      },
    ],
  },
  {
    key: 2,
    name: "Celebrity Website",
    image:
      "https://raw.githubusercontent.com/BandWebsite/HARRY-STYLES/main/ss/about.JPG",
    image2:
      "https://raw.githubusercontent.com/BandWebsite/HARRY-STYLES/main/ss/stripe.JPG",
    url: "/work/Celebrity Website",
    props: [
      {
        title: "PHP Backend",
        description: "Fully functional website with PHP backend and mysql db",
      },
      {
        title: "Checkout the project",
        description: "https://fhsmusic.herokuapp.com/",
      },
      {
        title: "APIs",
        description: "Worked with stripe API for payment",
      },
    ],
  },
  {
    key: 3,
    name: "Music Player using React",
    image:
      "https://raw.githubusercontent.com/mukherjeetejas/music-tejas/main/music%20app.PNG",
    image2:
      "https://raw.githubusercontent.com/mukherjeetejas/music-tejas/main/image2.PNG",
    url: "/work/Music Player using React",
    props: [
      {
        title: "Built using React",
        description:
          "Used react basics to understand how states/props etc work",
      },
      {
        title: "Copyright",
        description: "All music for this project is copyright free",
      },
      {
        title: "Checkout the project",
        description: "https://music-tejas.herokuapp.com/",
      },
    ],
  },
  {
    key: 4,
    name: "Vaccine Priority ML",
    image:
      "https://raw.githubusercontent.com/NeuralHack/VacQ/main/Flask%20ML%20model%20api/ss/Form.JPG",
    image2:
      "https://raw.githubusercontent.com/NeuralHack/VacQ/main/Flask%20ML%20model%20api/ss/pr1.JPG",
    url: "/work/Vaccine Priority ML",
    props: [
      {
        title: "Machine Learning",
        description:
          "Random forests is used to classify population with many attributes into three priorities for vaccines",
      },
      {
        title: "Flask",
        description: "Flask is used to connect ML model to web app",
      },
      {
        title: "Neural Hack",
        description:
          "We submitted this project to neural hack and received special mention",
      },
    ],
  },
  {
    key: 5,
    name: "tmReviews",
    image:
      "https://raw.githubusercontent.com/mukherjeetejas/tmReviews/main/tmReviewsPC2.PNG",
    image2:
      "https://raw.githubusercontent.com/mukherjeetejas/tmReviews/main/tmReviewsMob.jpeg",
    url: "/work/tmReviews",
    props: [
      {
        title: "MERN",
        description:
          "Website is built using full MERN stack, with CRUD capabilities.",
      },
      {
        title: "Redux",
        description: "Web App uses Redux to manage state making the process easier",
      },
      {
        title: "Checkout",
        description:
          "Upcoming",
      },
    ],
  },
];

export default ProjectData;
